import React, { useState } from 'react';
import axios from 'axios';
// import { useNavigate } from 'react-router-dom';


const ModalCreateUser = ({ isVisible, onClose }) => {

    function generatePassword() {
        var length = 20,
            charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
            retVal = "";
        for (var i = 0, n = charset.length; i < length; ++i) {
            retVal += charset.charAt(Math.floor(Math.random() * n));
        }
        return retVal;
    }

    function generateRoom_id() {
        var length = 15,
            charset = "0123456789",
            retVal = "";
        for (var i = 0, n = charset.length; i < length; ++i) {
            retVal += charset.charAt(Math.floor(Math.random() * n));
        }
        return retVal;
    }

    function generateId_pdv() {
        var length = 15,
            charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
            retVal = "";
        for (var i = 0, n = charset.length; i < length; ++i) {
            retVal += charset.charAt(Math.floor(Math.random() * n));
        }
        return retVal;
    }

    // const navigate = useNavigate();

    let error = document.getElementById('error')


    const [values, setValues] = useState({
        username: '',
        email:'',
        client_id:'',
        roles: '',
        id_pdv:'',
        password:'',
        room_id:'',
        pages:'all'
    })
    let role = []


    let token = localStorage.getItem("token");

    const headers = {
        'x-access-token': token,
        'Content-Type': 'application/json'
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        error.innerHTML = '';
        if(values.username === '' || values.email === '' || values.client_id === '' || values.roles === ''){
            error.innerHTML = "Veuillez renseigner tout les champs"
        }else{

            role.push(values.roles)
            // page.push(values.pages)
            values.roles = role;
            // values.pages = page;
            values.id_pdv = generateId_pdv();
            values.password = generatePassword();
            values.room_id = generateRoom_id();

            axios.post(`${process.env.REACT_APP_IP2}:${process.env.REACT_APP_PORT2}/api/auth/signup`, values, { headers })
            .then(res => {
                console.log(res);
                // navigate('/listusers');
                window.location.reload(false);
            }).catch(err => console.log(err))
        }
    }

    const handleClose = (e) => {
        if (e.target.id === "wrapper") onClose();
    }
    if (!isVisible) return null;
    return (
        <div className='fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 backdrop-blur-sm p-4' id="wrapper" onClick={handleClose}>
            <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg max-h-[85vh] overflow-y-auto">
                <div className="flex items-center justify-between border-b border-slate-200 px-6 py-4">
                    <h2 className="text-lg font-semibold text-slate-800">Nouvel utilisateur</h2>
                    <button type="button" className="text-slate-400 hover:text-slate-600" onClick={() => onClose()}>
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>
                <form className="px-6 py-5" onSubmit={handleSubmit}>
                    <div className="mb-4">
                        <label htmlFor="username" className="mb-1 block text-xs font-semibold uppercase tracking-wide text-slate-500">Nom Client</label>
                        <input type="text" name="username" id="username" className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-800 focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500/30" placeholder=" " required onChange={e => setValues({...values, username: e.target.value})}/>
                    </div>
                    <div className="mb-4">
                        <label htmlFor="email" className="mb-1 block text-xs font-semibold uppercase tracking-wide text-slate-500">Email</label>
                        <input type="text" name="email" id="email" className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-800 focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500/30" placeholder=" " required onChange={e => setValues({...values, email: e.target.value})}/>
                    </div>
                    <div className="mb-4">
                        <label htmlFor="clientId" className="mb-1 block text-xs font-semibold uppercase tracking-wide text-slate-500">Client ID</label>
                        <input type="text" name="clientId" id="clientId" className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-800 focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500/30" placeholder=" " required onChange={e => setValues({...values, client_id: e.target.value})}/>
                    </div>
                    <div className="mb-4">
                        <label htmlFor="stock" className="mb-1 block text-xs font-semibold uppercase tracking-wide text-slate-500">Droit</label>
                        <select id="stock" className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-800 focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500/30" onChange={e => setValues({ ...values, pages: e.target.value })}>
                            <option value="stock_only">Changement de Stock</option>
                            <option selected value="all">Changement Prix et Stock</option>
                        </select>
                    </div>
                    <div className="mb-4">
                        <label htmlFor="roles" className="mb-1 block text-xs font-semibold uppercase tracking-wide text-slate-500">Role</label>
                        <select id="roles" className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-800 focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500/30" onChange={e => setValues({...values, roles: e.target.value})} >
                            <option selected>Choisissez un role</option>
                            <option value="user_stock">Utilisatuer (stock uniquement)</option>
                            <option value="user">Gérant (stock et prix)</option>
                            <option value="moderator">Moderateur</option>
                            <option value="admin">Admin</option>
                        </select>
                    </div>
                    <button type="submit" className="w-full rounded-lg bg-indigo-500 px-4 py-2 text-sm font-medium text-white hover:bg-indigo-600">Submit</button>
                    <div className="py-4 text-center">
                        <p id="error" className='text-red-600'></p>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default ModalCreateUser;
